import { useTranslation } from 'react-i18next'
import ConfirmModal from '../../components/confirm-modal'

type Props = {
  visible: boolean
  closeModal: () => void
  externalUrl: string
}

const ExternalLinkModal = ({ visible, closeModal, externalUrl }: Props) => {
  const { t } = useTranslation()

  const goToExternalUrl = () => {
    closeModal()
    window.open(externalUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <ConfirmModal
      visible={visible}
      onClose={closeModal}
      title={t("You're leaving liv.rent")}
      subTitle={t('You will be re-directed to a third party website.')}
      onConfirm={goToExternalUrl}
      confirmText={t('common.continue', 'Continue')}
    />
  )
}

export default ExternalLinkModal
